'use client';

import Link from 'next/link';
import { withLocalePrefix } from '@/lib/localePath';
import type { Locale } from '@/lib/localePath';
import '@/styles/InfoPage.css';

type Props = { locale: Locale };

export default function TermsClient({ locale }: Props) {
    const t = (ja: string, en: string, es: string) => {
        if (locale === 'ja') return ja;
        if (locale === 'es') return es;
        return en;
    };

    return (
        <article className="info-page">
            <nav className="awards-breadcrumb">
                <Link href={withLocalePrefix(locale, '/')}>{t('ホーム', 'Home', 'Inicio')}</Link>
                {' › '}
                <span>{t('利用規約', 'Terms of Service', 'Terminos de servicio')}</span>
            </nav>
            <h1>{t('利用規約', 'Terms of Service', 'Terminos de servicio')}</h1>
            <p className="info-page-updated">
                {t('最終更新日: 2026-02-22', 'Last updated: 2026-02-22', 'Ultima actualizacion: 2026-02-22')}
            </p>

            <section>
                <h2>{t('適用', 'Acceptance', 'Aceptacion')}</h2>
                <p>
                    {t(
                        '本サイトを利用した時点で、本利用規約に同意したものとみなします。',
                        'By using this site, you agree to these terms of service.',
                        'Al usar este sitio, aceptas estos terminos de servicio.'
                    )}
                </p>
            </section>

            <section>
                <h2>{t('禁止事項', 'Prohibited Activities', 'Actividades prohibidas')}</h2>
                <ul>
                    <li>{t('不正アクセスや運営を妨害する行為', 'Unauthorized access or acts that disrupt service operation', 'Acceso no autorizado o acciones que afecten la operacion del sitio')}</li>
                    <li>{t('法令違反または公序良俗に反する行為', 'Illegal or harmful activities', 'Actividades ilegales o daninas')}</li>
                    <li>{t('自動化された過剰リクエスト等、過度な負荷を与える行為', 'Excessive automated requests or abusive scraping', 'Solicitudes automatizadas excesivas o scraping abusivo')}</li>
                </ul>
            </section>

            <section>
                <h2>{t('免責事項', 'Disclaimer', 'Descargo de responsabilidad')}</h2>
                <p>
                    {t(
                        '本サイトは情報の正確性や完全性を保証しません。本サイト利用により生じた損害について、運営者は責任を負いません。',
                        'We do not guarantee the accuracy or completeness of site information. The operator is not liable for damages resulting from use of this site.',
                        'No garantizamos la exactitud ni la integridad de la informacion. El operador no se hace responsable de danos derivados del uso del sitio.'
                    )}
                </p>
            </section>

            <section>
                <h2>{t('サービス変更・停止', 'Service Changes', 'Cambios del servicio')}</h2>
                <p>
                    {t(
                        '本サイトの内容は予告なく変更、停止、終了する場合があります。',
                        'Site content and functionality may be changed, suspended, or terminated without prior notice.',
                        'El contenido y las funciones del sitio pueden cambiar, suspenderse o finalizar sin aviso previo.'
                    )}
                </p>
            </section>

            <section>
                <h2>{t('規約の変更', 'Terms Modification', 'Modificacion de terminos')}</h2>
                <p>
                    {t(
                        '本規約は必要に応じて改定されます。改定後の規約は本ページ掲載時点から効力を持ちます。',
                        'These terms may be revised as needed. Revised terms become effective when posted on this page.',
                        'Estos terminos pueden actualizarse cuando sea necesario. Las versiones revisadas entran en vigor al publicarse en esta pagina.'
                    )}
                </p>
            </section>
        </article>
    );
}
